import { FC, memo } from 'react'
import { get } from 'lodash'
import * as Analytics from 'core/common/analytics'
import { VariationValue } from 'core/components/Multivariation'
import { BULK_FIELD_NAME } from 'core/components/Multivariation/constants'
import { IOptionProps } from 'core/components/VariationsAutocompleteField/types'
import { useFormContext } from 'core/pages/ProductNew-v2/context/ProductNewContext'
import { TProductInitialValues } from 'core/pages/ProductNew-v2/types'
import { IStoreValues, TVariationValues, useMultivariationValues } from '../store'
import { FlowCardProps } from '../types'
import { getSecondVariationFields } from './utils'

const SecondVariationValue: FC<FlowCardProps> = ({ onNext, handleEditStep, step, formMode }) => {
  const { setFormData } = useFormContext()
  const { getType, getValues, setValues } = useMultivariationValues()

  const firstType = getType('first')
  const variationType = getType('second')
  const storeValues = getValues()

  if (!variationType || !firstType) {
    return null
  }

  const fields = getSecondVariationFields(firstType, variationType, storeValues)

  const handleSubmit = (values: Record<string, IOptionProps[]>) => {
    const newValues = {} as IStoreValues['variationValues']
    const bulkValue = values[BULK_FIELD_NAME]

    fields.forEach(({ name }) => {
      const newFieldValue = {} as TVariationValues<string[] | null>
      const fieldValues = bulkValue || values[name]

      fieldValues.forEach(({ title }) => {
        newFieldValue[title] = get(storeValues, `${name}.${title}`, []) as string[]
      })

      newValues[name] = newFieldValue
    })

    Analytics.ProductVariationAttributeSaved(formMode)

    setValues(newValues)
    setFormData((prevData: TProductInitialValues) => ({
      ...prevData,
      selectedAttributes: newValues,
    }))

    onNext()
  }

  return (
    <VariationValue
      onSubmit={handleSubmit}
      variationType={variationType}
      showBulkMode
      fields={fields}
      onChange={() => handleEditStep(step.key)}
      handleEditStep={handleEditStep}
      formMode={formMode}
    />
  )
}

export default memo(SecondVariationValue)
